// import { nextFrame } from '@studiometa/js-toolkit/utils';
import { Tabs } from '@studiometa/ui';
import ToggledSectionChild from './ToggledSectionChild.js';

/**
 * withBreakpointObserver behavior component
 */
export default class ToggledSection extends Tabs {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'ToggledSection',
    emits: ['change', 'change-custom'],
    components: {
      ToggledSectionChild,
    },
    refs: [...Tabs.config.refs, 'toggleInput'],
    options: {
      styles: {
        type: Object,
        merge: true,
        default: () => ({
          btn: {
            closed: 'text-black-700',
          },
        }),
      },
    },
  };

  index = 0;

  /**
   * mounted
   */
  mounted() {
    super.mounted();
    this.activateByIndex(0);
  }

  /**
   * onBtnClick
   * @param {*} event
   * @param {*} index
   */
  onBtnClick(event, index) {
    this.index = index;
    super.onBtnClick(event, this.index);
    this.activateByIndex(this.index);
  }

  /**
   * onToggleInputClick
   * @param {*} event
   */
  onToggleInputClick(event) {
    if (this.index > 0) {
      this.index = 0;
    } else {
      this.index = 1;
    }
    this.onBtnClick(event, this.index);
    this.$emit('change-custom', this.index);
  }

  /**
   * activateByIndex
   * @param {number} index
   */
  activateByIndex(index) {
    this.index = index;

    this.items.forEach((item, i) => {
      if (i !== this.index) {
        this.disableItem(item);
      }
    });

    this.enableItem(this.items[this.index]);

    this.$children.ToggledSectionChild.forEach((child, childIndex) => {
      if (childIndex !== this.index) {
        child.hideItems();
        return;
      }
      child.showItems();
    });
    this.$refs.toggleInput.checked = this.index % 2 !== 0;
    this.$emit('change');
  }
}
